import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import countReducer from './redux/reducers/counterReducer';
import dataReducer from './redux/reducers/dataReducer';
import stepReducer from './redux/reducers/stepReducer';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

const rootReducer = combineReducers({
  countReducer,
  dataReducer,
  stepReducer
})

const store = createStore(rootReducer, composeWithDevTools(
  applyMiddleware(thunk),
  // other store enhancers if any
));

const root = document.getElementById('root');

const dataPath = {
  dataImagesPath: root.getAttribute('data-images-path'),
  dataApiPath: root.getAttribute('data-api-path')
}

const doc1= {
  url: root.getAttribute('ref-doc-1'),
  label: root.getAttribute('label-doc-1')
}
const doc2= {
  url: root.getAttribute('ref-doc-2'),
  label: root.getAttribute('label-doc-2')
}
const doc3= {
  url: root.getAttribute('ref-doc-3'),
  label: root.getAttribute('label-doc-3')
}
const doc4= {
  url: root.getAttribute('ref-doc-4'),
  label: root.getAttribute('label-doc-4')
}

const documentiPreventivatore = [doc1,doc2,doc3,doc4];
const linkInformativa = root.getAttribute('ref-informativa');
const linkTrasparenza = root.getAttribute('ref-trasparenza');
const linkSicurezza = root.getAttribute('ref-sicurezza');
const linkCookies = root.getAttribute('ref-cookies');
const linkPrivacy = root.getAttribute('ref-privacy');
const linkHome = root.getAttribute('ref-home');
const linkFiliali = root.getAttribute('ref-locator');
const linkPreventivatore = root.getAttribute('ref-preventivatore');
const linkCondizioniPolizza = root.getAttribute('ref-condizioni-polizza');
const docAssicurazione1 = root.getAttribute('ref-doc-ass-1');
const docAssicurazione2 = root.getAttribute('ref-doc-ass-2');
const docAssicurazione3 = root.getAttribute('ref-doc-ass-3');
const docAssicurazione4 = root.getAttribute('ref-doc-ass-4');

// accordions
const accordion1 = {
  title: root.getAttribute('ref-accordion-title-1'),
  text: root.getAttribute('ref-accordion-text-1')
}

const accordion2 = {
  title: root.getAttribute('ref-accordion-title-2'),
  text: root.getAttribute('ref-accordion-text-2')
}

const accordions = [accordion1, accordion2];




ReactDOM.render(
  //<React.StrictMode>
  <Provider store={store}>
    <App dataPath={dataPath}
          documentiPreventivatore={documentiPreventivatore}
          linkSicurezza={linkSicurezza}
          linkCookies={linkCookies}
          linkPrivacy={linkPrivacy}
          linkHome={linkHome}
          linkPreventivatore={linkPreventivatore}
          linkInformativa={linkInformativa}
          linkTrasparenza={linkTrasparenza}
          linkFiliali={linkFiliali}
          linkCondizioniPolizza={linkCondizioniPolizza}
          docAssicurazione1={docAssicurazione1}
          docAssicurazione2={docAssicurazione2}
          docAssicurazione3={docAssicurazione3}
          docAssicurazione4={docAssicurazione4}
          accordions={accordions}
          />
  </Provider>    
  //</React.StrictMode>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
